import { inject, provideAppInitializer } from '@angular/core';
import { PlatformService } from 'ngx-unificator/services';
import { WA_WINDOW } from 'ngx-unificator/tokens';
import { environment } from 'src/environments/environment';

export const provideMobConsole = () => {
  return [
    provideAppInitializer(() => {
      const platform = inject(PlatformService);
      const window = inject(WA_WINDOW);
      if (platform.isBrowser && environment.proxyMode) {
        const script = window.document.createElement('script');
        script.src = '//cdn.jsdelivr.net/npm/eruda';
        script.onload = () => {
          window?.['eruda']?.init();
        };
        window.document.body.appendChild(script);
      }
    }),
  ];
}
